export default __webpack_public_path__ + "static/media/026-rocket.49c3adb2.svg";